import layoutEngine from "../libraries/layoutEngine";
let designName = "Untitled_Design";
let selectedInstanceCell = null; // ✅ NEW: store selected cell for instance placement
let currentTool = "select";
// add code
let topCellName = null;
let selectedCell = null;
let showOnlySelected = false;         // ⬅️ checkbox toggle
let selectedPattern = null;  

const ProjectManager = {
  getDesignName: () => designName,

  setDesignName: (name) => {
    designName = name;
    console.log("Design name set to:", designName);
  },

  findRootCell: () => {
    const created = layoutEngine.getCells();
    const uploaded = layoutEngine.getUploadedCells();
    const allCells = [...created, ...uploaded];

    if (!allCells.length) return null;

    const allNames = new Set(allCells.map(c => c.name));
    const referenced = new Set();

    for (const cell of allCells) {
      for (const inst of cell.instances || []) {
        if (inst.ref) referenced.add(inst.ref);
      }
    }

    // Root = cells that are not referenced
    for (const name of allNames) {
      if (!referenced.has(name)) return name;
    }

    return null;
  },

  // ✅ New Methods:
  getSelectedInstanceCell: () => selectedInstanceCell,
  //shiv code
  getSelectedCell: () => selectedCell,
  setSelectedCell: (cellName) => {
    selectedCell = cellName;
    window.canvasEngine.selectedObjects = [];
    window.canvasEngine.draw(); // 🔁 trigger re-draw when cell changes
    window.dispatchEvent(new Event("cell-changed")); // 🔥 notify UI
  },
  getTopCellName: () => {
  return topCellName || ProjectManager.findRootCell();
},

  setTopCellName: (name) => { topCellName = name; },
  // end shiv code

  setSelectedInstanceCell: (name) => {
    selectedInstanceCell = name;
    console.log("Selected cell for instance:", selectedInstanceCell);
  },
  getTool: () => currentTool,
  setTool: (toolName) => {
    currentTool = toolName;
    console.log("🛠️ Tool set to:", currentTool);
  },

  // parametric pattern management
  
  setShowOnlySelected: (value) => {
  showOnlySelected = value;
  console.log("🔘 Show only selected:", value);
  window.canvasEngine?.draw(); // redraw
},

getShowOnlySelected: () => showOnlySelected,

setSelectedPattern: (patternName) => {
  selectedPattern = patternName;
  console.log("🎯 Selected pattern:", patternName);
  window.canvasEngine?.draw(); // redraw
},

getSelectedPattern: () => selectedPattern,

  
};

export default ProjectManager;
